// DS: i3.30
import React from 'react';
import IconWrap from '../../IconWrap';
const ChangeSkin = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 2c5.522 0 10 3.978 10 8.889a5.558 5.558 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667 0 .422.167.811.422 1.1.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22 6.478 22 2 17.522 2 12S6.478 2 12 2Zm-1.189 16.111a3.6648 3.6648 0 0 1 .2783-1.4038 3.6656 3.6656 0 0 1 1.9849-1.9849 3.6648 3.6648 0 0 1 1.4038-.2783h1.966A3.558 3.558 0 0 0 20 10.89C20 7.139 16.468 4 12 4a8 8 0 0 0-.676 15.972 3.6522 3.6522 0 0 1-.513-1.861ZM7.5 12a1.5 1.5 0 1 1-.0001-3A1.5 1.5 0 0 1 7.5 12Zm9 0a1.5001 1.5001 0 1 1 0-3.0002A1.5001 1.5001 0 0 1 16.5 12ZM12 9a1.5001 1.5001 0 0 1-1.0607-2.5607 1.5001 1.5001 0 0 1 2.1214 2.1214A1.5001 1.5001 0 0 1 12 9Z",
        fill: "currentColor"
    })));
};
ChangeSkin.displayName = 'ChangeSkin';
export default ChangeSkin;

//# sourceMappingURL=ChangeSkin.js.map